export default "__VITE_ASSET__CkHDru_w__"